import React from 'react';
import {Modal, Form, Button, Radio} from 'antd';
import GroupTreeMultiSelect from './GroupTreeMultiSelect'
import {GROUP_MANAGEMENT_ROLE, GROUP_CONTROL_ROLE, GROUP_MONITORING_ROLE} from '../constants/defaultValues'
const FormItem = Form.Item;

class AccountRoleGroupModalForm extends React.Component {
  handleSelectedKeys = (selectedKeys) => {
    const {form} = this.props
    form.setFieldsValue({selectedKeys: selectedKeys});
  }

  render() {
    const {
      domains,
      role,
      groups,
      treeGroups,
      fetchingGroups,
      fetchingPermissions,
      title,
      visible,
      onCancel,
      onSubmit,
      form
    } = this.props
    const {getFieldDecorator} = form
    const initialRole = (role === GROUP_MANAGEMENT_ROLE || role === GROUP_CONTROL_ROLE || role === GROUP_MONITORING_ROLE)
      ? role
      : undefined
    const selectedKeys = domains.filter((domain) => {
      const index = groups.findIndex((group) => {
        return group.ID === domain
      })
      return index > -1
    })
    return (<Modal visible={visible} title={title} width={512} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
        <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
        <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
          Lưu
        </Button>
      ]}>
      <Form layout="vertical">
        <FormItem label="Quyền">
          {
            getFieldDecorator('role', {
              rules: [
                {
                  required: true,
                  message: 'Phải chọn quyền!'
                }
              ],
              initialValue: initialRole
            })(<Radio.Group size="small">
              <Radio.Button value={GROUP_MANAGEMENT_ROLE}>Quản lý</Radio.Button>
              <Radio.Button value={GROUP_CONTROL_ROLE}>Điều khiển</Radio.Button>
              <Radio.Button value={GROUP_MONITORING_ROLE}>Giám sát</Radio.Button>
            </Radio.Group>)
          }
        </FormItem>
        {
          (!fetchingGroups && !fetchingPermissions)
            ? <FormItem label="Danh sách địa bàn">
                {
                  getFieldDecorator('selectedKeys', {
                    rules: [
                      {
                        required: true,
                        message: 'Phải chọn địa bàn!'
                      }
                    ],
                    initialValue: selectedKeys
                  })(<GroupTreeMultiSelect groups={groups} treeGroups={treeGroups} selectedKeys={selectedKeys} onSelectedKeys={this.handleSelectedKeys}/>)
                }
              </FormItem>
            : null
        }
      </Form>
    </Modal>);
  }
}

export default Form.create()(AccountRoleGroupModalForm)



// WEBPACK FOOTER //
// ./src/components/AccountRoleGroupModalForm.js